import axios from 'axios';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { API_PATH } from '../config/constants';

interface Configuration {
	origin: string;
	apiPath: string;
	ssePath: string;
}

const configuration: Configuration = {
	origin: window.origin,
	apiPath: API_PATH,
	ssePath: API_PATH,
};

const baseUrl = () => {
	// NOTE: use for local debugging 'http://localhost:8080';
	return window.origin;
};

const ApiClient = axios.create({
	baseURL: `${baseUrl()}${API_PATH}`,
	headers: {
		'X-BFF-CSRF': 'true',
	},
});

export function getSseClient(relativeUrl: string): EventSourcePolyfill {
	const fullUrl = `${baseUrl()}${configuration.ssePath}${relativeUrl}`;

	const headers: Record<string, string> = {
		'X-BFF-CSRF': 'true',
	};

	const sse = new EventSourcePolyfill(fullUrl, {
		headers,
	});

	return sse;
}

export default ApiClient;
